import { createClientsApi } from '@metapic-apps/shared'

import { handleErrorMessage } from '@/lib/helpers/error.helpers'
import { metapicApiClient } from '@/lib/services/metapic-api.service'
import { useErrorStore } from '@/stores/error'

export const { useClientsList, createLoadClientsForCriteria, createLoadRevenueTiersForCriteria } =
  createClientsApi({
    listClients: (params) => metapicApiClient.clientsIndex(params),
    useErrorReporter: () => {
      const errorStore = useErrorStore()

      return (e: unknown) => errorStore.setError(handleErrorMessage(e))
    },
  })
